import { P2GButton } from '@parcel2go/peacock-legacy-core/dist/button';
import React, { useEffect, useState } from 'react';
import { ActionType, IntegrationTermsAndConditions, IntergrationInstructionStep, StrVal } from '../services/api/types';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import Step, { StepRow } from './Step';
import { P2GFade } from '@parcel2go/peacock-legacy-core/dist/transitions';
import { IsIntegrationValid } from '../services/helpers/ValidateIntegration';
import { P2GBox } from '@parcel2go/peacock-legacy-core/dist/box';
import StepInput from './StepInput';
import TermsLabel from './TermsLabel';

interface props {
  action: ActionType;
  steps: IntergrationInstructionStep[];
  hasInputs: boolean;
  showInstructions: boolean;
  saving: boolean;
  readonly: boolean;
  onSubmit: (values: StrVal) => void;
  terms: IntegrationTermsAndConditions;
}

const Steps: React.FC<props> = (props) => {
  const [values, setValues] = useState<StrVal>({});
  const [isValid, setIsValid] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let initialValues: StrVal = {};
    props.steps?.forEach((s) => {
      s?.inputs.forEach((i) => {
        if (i.value && !initialValues[i.propertyName]) {
          initialValues[i.propertyName] = i.value;
        }
      });
    });
    setIsValid(IsIntegrationValid(initialValues, props.steps, props.terms));
    setValues(initialValues);
    setLoading(false);
  }, [props.steps]);

  const onUpdate = (key: string, value: string) => {
    var x = { ...values };
    x[key] = value;
    setValues(x);
    setIsValid(IsIntegrationValid(x, props.steps, props.terms));
  };

  const showNumber = props.showInstructions && props.steps.length > 1;

  if (loading) {
    return null;
  }

  return (
    <P2GGrid container spacing={props.showInstructions ? 5 : 1} direction="column" key={`${props.showInstructions}`}>
      {props.steps.map((s, index) => (
        <P2GGrid item key={`${index}`}>
          <P2GFade in timeout={(index + 1) * 550}>
            <Step
              saving={props.saving}
              step={s}
              showInstructions={props.showInstructions}
              showNumber={showNumber}
              stepNumber={index + 1}
              values={values}
              onUpdate={onUpdate}
            />
          </P2GFade>
          {!props.readonly && index == props.steps.length - 1 && (
            <StepRow
              left={!!showNumber}
              right={
                <>
                  {props.terms && (
                    <P2GBox mt={props.hasInputs ? 2 : 0}>
                      <TermsLabel
                        disabled={props.saving}
                        terms={props.terms}
                        value={values[props.terms.input.propertyName]}
                        onUpdate={onUpdate}
                      />
                    </P2GBox>
                  )}
                  <P2GBox mt={props.hasInputs ? 2 : 0}>
                    <P2GButton
                      disabled={!isValid || props.saving}
                      onClick={() => props.onSubmit(values)}
                      colour="primary">
                      {props.action} Account
                    </P2GButton>
                  </P2GBox>
                </>
              }
            />
          )}
        </P2GGrid>
      ))}
    </P2GGrid>
  );
};

export default Steps;
